const GSM_BASIC =
  "@£$¥èéùìòÇ\nØø\rÅå_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?" +
  "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§" +
  "¿abcdefghijklmnopqrstuvwxyzäöñüà";

/** GSM 03.38 extension table — two septets each (escape + character). */
const GSM_EXTENDED = "^{}\\[~]|€";

const GSM_BASIC_SET = new Set(GSM_BASIC.split(""));
const GSM_EXTENDED_SET = new Set(GSM_EXTENDED.split(""));

const GSM_SINGLE = 160;
const GSM_CONCATENATED = 153;
const UCS2_SINGLE = 70;
const UCS2_CONCATENATED = 67;

export type SmsEncoding = "GSM-7" | "UCS-2";

export interface ISmsCost {
  characters: number;
  encoding: SmsEncoding;
  segments: number;
  /** The characters that forced UCS-2, de-duplicated — what the editor points at. */
  offenders: string[];
}

export function measureSms(body?: string | null): ISmsCost {
  const text = String(body || "");
  const characters = Array.from(text);

  const offenders = Array.from(
    new Set(
      characters.filter(
        (char) => !GSM_BASIC_SET.has(char) && !GSM_EXTENDED_SET.has(char),
      ),
    ),
  );

  if (!text) {
    return { characters: 0, encoding: "GSM-7", segments: 0, offenders };
  }

  if (!offenders.length) {
    const units = characters.reduce(
      (total, char) => total + (GSM_EXTENDED_SET.has(char) ? 2 : 1),
      0,
    );

    return {
      characters: characters.length,
      encoding: "GSM-7",
      segments: units <= GSM_SINGLE ? 1 : Math.ceil(units / GSM_CONCATENATED),
      offenders,
    };
  }

  // UCS-2 counts UTF-16 code units, so an emoji outside the BMP costs two.
  return {
    characters: characters.length,
    encoding: "UCS-2",
    segments:
      text.length <= UCS2_SINGLE
        ? 1
        : Math.ceil(text.length / UCS2_CONCATENATED),
    offenders,
  };
}
